export default "__VITE_ASSET__BHhpmjE$__"